import { SnackbarProgrammatic as Snackbar } from 'buefy'
import API from '@/api'
import router from '@/router'

const actions = {
  getCollection({ commit }, payload) {
    API.tours.getCollection(payload)
      .then(({ data: { data: { results }, include: { filters, minPrices }, meta } }) => {
        if (!results.length && payload.isSearch) {
          commit('setEmptySearchResults', true)
        }

        if (meta.page === 1) {
          commit('setCollection', results)
          commit('setCollectionFilters', filters)
          commit('setMinPrices', minPrices)

          if (payload.isSearch) {
            commit('setField', {
              target: 'filters.priceFrom',
              value: filters.price.priceFrom
            })
            commit('setField', {
              target: 'filters.priceTo',
              value: filters.price.priceTo
            })
          }
        } else {
          commit('updateCollection', results)
        }

        commit('updatePagination', meta)
      })
      .catch(({ data: { errors } }) => {
        if (router.currentRoute.name === 'ToursSearch') {
          commit('setErrors', errors)
          commit('setFormShowed', true)
          commit('setSearchShowed', false)
        }
      })
      .finally(() => {
        commit('setIsLoading', false)
        commit('setIsUpdating', false)
        commit('setIsFiltersDisabled', false)
        commit('setIsLoadingMore', false)
      })
  },
  getDepartureCities({ commit }, payload) {
    API.autocomplete.getToursOrigins(payload)
      .then(({ data: { data: { results } } }) => {
        commit('setDepartureCities', {
          collection: results[0].collection
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось загрузить список мест отправления.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('setDepartureCities', {
          isLoading: false
        })
      })
  },
  getCalendar({ commit }, payload) {
    API.flights.getFlightCalendar(payload)
      .then(({ data: { data: { results } } }) => {
        commit('setCalendar', results)
      })
      .finally(() => {
        commit('setIsCalendarLoading', false)
      })
  }
}

export default actions